import { ChangeDetectorRef, Component, forwardRef, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { defer, finalize, Subject, takeUntil } from 'rxjs';
import { AutopropBackend, Response } from '../backend';
import { FileUploadRequest } from './file-drop.model';
import { ImageUploadComponent } from './image-upload.component';


@Component({
    selector: 'image-input',
    imports: [
        ImageUploadComponent,
    ],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ImageInputComponent), multi: true },
    ],
    template: `
        <image-upload
            [folder]="folder"
            [fileUrl]="imageUrl"
            (fileUploaded)="onFileUploaded($event)"
            (fileRemoved)="onFileRemove()"
            [inLoading]="loading"
            [description]="description"
            [aspectRatio]="aspectRatio"
            [withResize]="withResize"
            [maxWidth]="maxWidth">
        </image-upload>
    `,
})
export class ImageInputComponent implements ControlValueAccessor, OnDestroy {

    @Input() folder: string;

    @Input() aspectRatio = 1;

    @Input() maxWidth = 0;

    @Input() withResize = false;

    @Input() description = 'Must be .jpg .png, .gif and a file size no larger than 5MB.';

    imageUrl: string | null;

    loading = false;

    private onChange = (_: string | null) => {};

    private onTouch = () => {};

    private destroyed = new Subject<void>();

    constructor(private backend: AutopropBackend, private cdr: ChangeDetectorRef) {}

    onFileUploaded(fr: FileUploadRequest) {
        defer(() => {
            this.loading = true;
            fr.formData.append('folder', this.folder);
            return this.backend.postFile('/api/file/upload-image', fr.formData);
        })
            .pipe(
                finalize(() => {
                    this.loading = false;
                    this.cdr.detectChanges();
                }),
                takeUntil(this.destroyed)
            )
            .subscribe((uploadedCover: Response) => {
                this.imageUrl = uploadedCover.payload.image;
                this.cdr.detectChanges();
                this.onChange(this.imageUrl);
                this.onTouch();
            });
    }

    onFileRemove() {
        this.imageUrl = null;
        this.onChange(this.imageUrl);
        this.onTouch();
    }

    writeValue(obj: any) {
        this.imageUrl = obj;
        this.cdr.detectChanges();
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouch = fn;
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
